// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"8b932f25","170":"c2f817d8","453":"a2de1bb7","455":"a7670ba1","857":"fff21746","977":"61537a3d"}[chunkId] + ".chunk.js";
};